import type { FC } from "react";
import { useEffect } from "react";
import { useLoadingScreenContext } from "./LoadingScreenContext.tsx";

export const LoadingScreen: FC<React.PropsWithChildren<unknown>> = () => {
  const { show, hide } = useLoadingScreenContext();

  useEffect(() => {
    show();

    return () => hide();
  }, [show, hide]);

  return null;
};
